<app-header></app-header>
<nav class="breadcrumb">
    <div class="home">
        <img src="assets/images/home.svg" alt="" />
        <a (click)="navigateToHome()">Home</a>
        <img src="assets/images/nav-arrow-right.svg" alt="" *ngIf="breadcrumbItems.length > 0" />&nbsp;
    </div>

    <ng-container *ngFor="let item of breadcrumbItems; let i = index">
        <a *ngIf="item.url; else plain" [routerLink]="item.url">{{ item.label }}</a>
        <ng-template #plain><span>{{ item.label }}</span></ng-template>
        <span *ngIf="i < breadcrumbItems.length - 1">
            <img src="assets/images/nav-arrow-right.svg" alt="" />
        </span>
    </ng-container>
</nav>
<div id="content" class="container-fluid">
    <router-outlet></router-outlet>
</div>
<app-footer></app-footer>